/* eslint-disable react/prop-types */
import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import { Grid, Box } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import { permissons } from '_mocks/permissonLabels';
import { SwitchStyles2, topBarStyles } from '../../administratorStyles';

export default function Switch({
  permissionLabel,
  permissionName,
  value,  // { READ: true, WRITE: false }
}) {
  const classes = topBarStyles();

  return (
    <FormGroup>
      <Typography component="div">
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            <Typography className={classes.permissKey}>{permissionLabel}</Typography>
            <Box className={classes.displayFlex}>
              {Object.entries(value || {}).map(([actionName, isEnabled]) =>
                permissons?.[permissionName]?.[actionName] !== undefined ? (
                  <Box className={classes.displayFlex1} key={actionName}>
                    <SwitchStyles2
                      name={`permissions.${permissionName}.${actionName}`}
                      checked={Boolean(isEnabled)}
                      isReadOnly
                      id={`permissions.${permissionName}.${actionName}`}
                    />
                    <Typography className={classes.labelKey}>
                      {permissons?.[permissionName]?.[actionName]}
                    </Typography>
                  </Box>
                ) : null
              )}
            </Box>
          </Grid>
        </Grid>
      </Typography>
    </FormGroup>
  );
}
